import { render } from "./ActivationSuccess.vue?vue&type=template&id=816d8834"
import script from "./ActivationSuccess.vue?vue&type=script&lang=js"
export * from "./ActivationSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__